import React from "react";
import { Calendar, Badge, Whisper, Popover, HStack, VStack, Tag } from "rsuite";
import {
  Card,
  Flex,
  Heading,
  Text,
  Divider,
  TextField,
  Button,
} from "@aws-amplify/ui-react";
import { useForm, Controller } from "react-hook-form";

import "rsuite/Calendar/styles/index.css";
import "rsuite/Badge/styles/index.css";
import "rsuite/Popover/styles/index.css";
import "rsuite/Tag/styles/index.css";

import { useSymptomsQuery } from "../../healthRecords/api/useSymptomsQuery";
import { formatDate, dateCheck } from "../../common/useDateFunctions";
import { useUserQuery } from "../../common/useUserQuery";

export default function SymptomsGraphContainer() {
  const { data: userQueryData } = useUserQuery();
  const { data, isLoading, error } = useSymptomsQuery(
    userQueryData?.patientUserId
  );

  const [isMobile, setIsMobile] = React.useState(false);
  const [date, setDate] = React.useState(new Date());

  //choose the screen size
  const handleResize = () => {
    if (window.innerWidth < 1290) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  // create an event listener
  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
  });
  const renderCell = (date) => {
    const tmpDate = formatDate(new Date(date));
    const tmpSymptoms = data.filter((item) =>
      dateCheck(item.symptomStartDate, item.symptomEndDate, tmpDate)
    );
    //const displayList = tmpSymptoms.filter((item, index) => index < 1);
    const moreCount = tmpSymptoms.length;
    const moreItem = (
      <li style={{ listStyleType: "none" }}>
        <Whisper
          placement="top"
          trigger="click"
          speaker={
            <Popover>
              {tmpSymptoms.map((item, index) => (
                <div key={index}>
                  <Badge color={item.active === 0 ? "green" : "red"} />{" "}
                  <b>{item.symptom}</b>
                </div>
              ))}
            </Popover>
          }
        >
          <a style={{ color: "#057d95" }}>
            {moreCount} {moreCount === 1 ? "Symptom" : "Symptoms"}
          </a>
        </Whisper>
      </li>
    );
    return (
      <ul className="calendar-todo-list">
        {/* {displayList &&
          displayList.map((item, index) => {
            return (
              <li key={index} style={{ listStyleType: "none" }}>
                <Badge color={item.active === 0 ? "green" : "red"} />{" "}
                <b>{item.symptom}</b>
              </li>
            );
          })} */}
        {moreCount ? moreItem : null}
      </ul>
    );
  };
  const renderCellMobil = (date) => {
    const tmpDate = formatDate(new Date(date));
    const tmpSymptoms = data.filter((item) =>
      dateCheck(item.symptomStartDate, item.symptomEndDate, tmpDate)
    );

    return (
      tmpSymptoms &&
      tmpSymptoms.length > 0 && (
        <div style={{ position: "relative" }}>
          <Text as="span" muted size="sm">
            <li style={{ listStyleType: "none" }}>
              <Badge color="grey" />{" "}
            </li>
          </Text>
        </div>
      )
    );
  };

  const DayView = ({ date }) => {
    const tmpDate = formatDate(new Date(date));
    const tmpSymptoms = data.filter((item) =>
      dateCheck(item.symptomStartDate, item.symptomEndDate, tmpDate)
    );
    return (
      <VStack spacing={10}>
        <HStack>
          <Text size="xl">{formatDate(date)}</Text>
        </HStack>
        <HStack>
          <Tag as="span" color="blue">
            {!tmpSymptoms || tmpSymptoms?.length <= 0
              ? "No symptoms registered."
              : "Symptoms:"}
          </Tag>
          <HStack wrap style={{ maxWidth: 300 }}>
            <ul className="calendar-todo-list">
              {tmpSymptoms &&
                tmpSymptoms.map((item, index) => {
                  return (
                    <li key={index} style={{ listStyleType: "none" }}>
                      <Badge color={item.active === 0 ? "green" : "red"} />{" "}
                      <b>{item.symptom}</b>
                    </li>
                  );
                })}
            </ul>
          </HStack>
        </HStack>
      </VStack>
    );
  };

  if (isLoading) return "Loading...";

  if (error) return "Error loading todos, check console for output";
  if (!isMobile) {
    return (
      <Card variation="elevated">
        <Flex direction={"column"} gap={12}>
          <Heading level={5} children={`Symptoms History Graph`} />
          <Flex
            direction={"row"}
            gap={12}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Badge color="red" />
            Symptoms present
          </Flex>
          <Flex
            direction={"row"}
            gap={12}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Badge color="green" />
            Symptoms not present
          </Flex>
        </Flex>
        <Flex direction={"column"} gap={12}>
          <Calendar bordered renderCell={renderCell} />
        </Flex>
      </Card>
    );
  } else {
    return (
      <HStack divider={<Divider />} spacing={40} wrap>
        <Calendar
          compact
          bordered
          style={{ width: 340 }}
          onChange={setDate}
          renderCell={renderCellMobil}
        />
        <DayView date={date} />
      </HStack>
    );
  }
}
